import React, { Component } from 'react'
import { withLocalize, Translate } from 'react-localize-redux'

class NoDataComponent extends Component {
    render() {
        return (
            <div className="no-data" style={this.props.style}>
                <Translate id= {this.props.customLabel != null ? this.props.customLabel : "Search.NoData"} />
                {this.props.back}
            </div>
        )
    }
}

export default withLocalize(NoDataComponent);
